import { useInfiniteScroll } from '../../hooks/useInfiniteScroll';
import { UseInfiniteFeedProps } from './useInfiniteFeed.types';
import { useFeedData } from './useFeedData';

/**
 * Комбинированный хук для бесконечной подгрузки данных в ленту
 * Объединяет useInfiniteScroll и useFeedData для удобного использования
 * @param pageSize - Количество элементов на одной странице
 * @param threshold - Расстояние от низа страницы для начала загрузки
 * @returns Объект с данными промптов и методами для управления бесконечной подгрузкой
 */

export const useInfiniteFeed = ({ threshold = 200, category }: UseInfiniteFeedProps) => {
    const { prompts, collections, courses, challenges, loading, hasMore, loadMore, reset } = useFeedData({ category });

    const { loadMore: scrollLoadMore, containerRef } = useInfiniteScroll(loadMore, {
        threshold,
        enabled: true,
        hasMore,
        loading,
    });

    return {
        prompts,
        collections,
        courses,
        challenges,
        loading: loading,
        hasMore: hasMore,
        loadMore: scrollLoadMore,
        reset,
        containerRef,
    };
};
